<template>
  <div v-if="show" class="huabeiCeng" @click="cengClick()">
    <img src="./img/huabeiCeng_icon.png" >
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    show: Boolean
  },
  methods: {
    cengClick() {
      this.$emit('update:show', false);
    }
  }
};
</script>

<style lang='stylus' scoped>
.huabeiCeng
  position fixed
  width 100vw
  height 100vh
  left 0
  top 0
  background-color rgba(0, 0, 0, 0.6)
  img
    position relative
    float right
    width 80%
    margin-right 20px
</style>